module.exports = __webpack_public_path__ + "media/dorobek/assets/images/icons/uczelnia-black-contrast-f5f1429500ccaad84abf24d5c1923986.svg";